import { useMemo } from 'react';

import { sanitizeEmailHtml } from '../../helpers/SanitizeHtml';

interface CorpsEmailProps {
    html: string;
    /** Nom accessible de l'iframe : l'objet de l'e-mail. */
    titre: string;
}

/**
 * Mise en page de base, posée AVANT le HTML de l'e-mail : ses propres styles
 * passent après et l'emportent. Ce texte est le nôtre, pas du contenu reçu.
 */
const STYLE_BASE =
    '<style>body{margin:12px 16px;font-family:-apple-system,system-ui,sans-serif;' +
    'overflow-wrap:anywhere}img{max-width:100%;height:auto}</style>';

/**
 * Le corps d'un e-mail reçu, en plein écran (#16). C'est du HTML étranger : rendu
 * en ligne, ses `<style>` globaux restylaient toute l'app (jusqu'à masquer
 * « Fermer ») et un formulaire pouvait imiter l'écran de connexion.
 *
 * Il vit donc dans un iframe `srcdoc` sandboxé :
 * - ni `allow-scripts`, ni `allow-forms`, ni `allow-same-origin` : aucun script,
 *   aucune soumission, aucun accès à la session de l'app ;
 * - `allow-popups` + `allow-popups-to-escape-sandbox` : le helper force les liens
 *   en `target="_blank"`, ils s'ouvrent hors de l'app (feuille Safari en
 *   standalone iOS), jamais à la place de l'app.
 */
export default function CorpsEmail({ html, titre }: CorpsEmailProps) {
    const srcDoc = useMemo(() => STYLE_BASE + sanitizeEmailHtml(html), [html]);

    return (
        <iframe
            title={titre}
            sandbox="allow-popups allow-popups-to-escape-sandbox"
            srcDoc={srcDoc}
            className="min-h-0 w-full flex-1 border-0 bg-white"
        />
    );
}
